import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d9a884f"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["disabled"]

import { ref } from "vue";
import LoadingSpinner from "./LoadingSpinner.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'UButton',
  props: {
    square: { type: Boolean },
    color: {},
    disabled: { type: Boolean },
    position: {},
    onClick: {},
    dontLoad: { type: Boolean },
    big: { type: Boolean }
  },
  emits: ["click"],
  setup(__props: any) {


const props = __props;

const loading = ref<boolean>();

function hasWhiteText() {
  return props.color == "green" || !props.color;
}
async function clicked() {
  if (!props.onClick || typeof props.onClick !== "function") return;

  loading.value = true;
  try {
    await props.onClick();
  } finally {
    loading.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["umana-btn border-solid flex items-center justify-center", {
      'aspect-square': props.square == true,
      'bg-white': props.color == 'white',
      'bg-orange-3': props.color == 'orange',
      'bg-blue': props.color == 'blue',
      'bg-green': props.color == 'green' || !props.color,
      'bg-transparent': props.color == 'red',
      'border-red-2': props.color == 'red',
      'text-red-2': props.color == 'red',
      'text-white': hasWhiteText(),
      'text-black': !hasWhiteText(),
      'border-lighten': hasWhiteText(),
      'border-darken': !hasWhiteText(),
      'rounded-r': !props.position || props.position == 'right',
      'rounded-l': !props.position || props.position == 'left',
      'border-l-2':
        !props.position ||
        props.position == 'left' ||
        props.position == 'middle',
      'border-r-2':
        !props.position ||
        props.position == 'right' ||
        props.position == 'middle',
      'border-t-2': true,
      'border-b-2': true,
      'text-center': true,
      '!font-semibold': props.big,
      '!text-xl': props.big,
    }]),
    disabled: _ctx.disabled || loading.value,
    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.dontLoad ? _ctx.$emit('click') : clicked()), ["prevent"]))
  }, [
    (loading.value)
      ? (_openBlock(), _createBlock(LoadingSpinner, {
          key: 0,
          class: "mr-xs w-ms"
        }))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default")
  ], 10, _hoisted_1))
}
}

})